module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("First published in 2023 by")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Birlinn Ltd")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("West Newington House")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Edinburgh eh9 1qs")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("10 Newington Road")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.birlinn.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.birlinn.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Copyright © John H. Reid 2023")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("ISBN 978 1 78885 580 8")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("The right of John H. Reid to be identified as author of this work has been asserted by him in accordance with the Copyright, Designs and Patents Act 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored, or transmitted in any form, or by any means, electronic, mechanical or photocopying, recording or otherwise, without the express written permission of the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("British Library Cataloguing in Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("A catalogue record for this book is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Designed and typeset by Mark Blackadder")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Printed and bound by PNB, Latvia")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aefbb34e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 63
// module chunks = 0